"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { CircleHelp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useOnboardingTours } from "@/features/onboarding-tours/context/use-onboarding-tours";
import { shouldShowCatalogLauncherBeacon } from "@/features/onboarding-tours/lib/should-show-catalog-launcher-beacon";
import { useTierGuard } from "@/hooks/use-tier-guard";
import { useUserData } from "@/hooks/useUserData";
import { cn } from "@/lib/utils";
export function TourHelpButton() {
  const $ = _c(13);
  const {
    hasFullProductAccess,
    isTierResolved
  } = useTierGuard();
  const {
    setCatalogOpen
  } = useOnboardingTours();
  const {
    userData
  } = useUserData();
  const t0 = userData?.createdAt;
  let t1;
  if ($[0] !== t0) {
    t1 = shouldShowCatalogLauncherBeacon({
      accountCreatedAt: t0
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showBeacon = t1;
  if (!isTierResolved || !hasFullProductAccess) {
    return null;
  }
  let t2;
  if ($[2] !== setCatalogOpen) {
    t2 = () => {
      setCatalogOpen(true);
    };
    $[2] = setCatalogOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CircleHelp className="size-4" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== showBeacon) {
    t4 = showBeacon ? <span aria-hidden={true} className="pointer-events-none absolute -top-px right-0.5 flex size-2"><span className={cn("absolute inline-flex size-full rounded-full bg-destructive/50", "motion-safe:animate-ping")} /><span className="relative inline-flex size-2 rounded-full bg-destructive" /></span> : null;
    $[5] = showBeacon;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <TooltipTrigger asChild={true}><Button aria-label="Open product tours" className="relative size-7" onClick={t2} size="icon" type="button" variant="ghost">{t3}{t4}</Button></TooltipTrigger>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TooltipContent side="bottom">Product tours</TooltipContent>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <Tooltip>{t5}{t6}</Tooltip>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}